// react
import { useEffect, useState } from 'react'

// components
import Accordion from '../../../../../control/accordion/accordion'
import OfficeFilesForm from './OfficeFilesForm'

// hooks
import useLoading from '../../../../../control/loading/useLoading'
import useTranslate from '../../../../../i18n/useTranslate'
import useOfficeFile, { OfficeFile } from '../../../../../services/web/useOfficeFile'

export interface ProjectFilesUploadProps {
    projectID: number
}

function ProjectFilesUpload(props: ProjectFilesUploadProps) {
    const { projectID } = props

    const translate = useTranslate()
    const officeFileServices = useOfficeFile()
    const loadingHook = useLoading()

    const [initialValues, setInitialValues] = useState<OfficeFile>()

    useEffect(() => {
        async function fetcOfficeFile() {
            loadingHook.loadingOpen()
            try {
                const { result } = await officeFileServices.getOfficeFiles(projectID)
                setInitialValues(result)
            } catch (error) {
                console.error(error)
            } finally {
                loadingHook.loadingClose()
            }
        }

        fetcOfficeFile()
    }, [projectID])

    return (
        <Accordion title={translate.get('LABEL.UPLOAD_FILES')}>
            <OfficeFilesForm projectID={projectID} initialValues={initialValues} />
        </Accordion>
    )
}

export default ProjectFilesUpload
